import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from './config';
import { mapStorageError } from '../utils/storageErrors';

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export async function uploadUserLogo(userId, file) {
  // Validazione tipo
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error('Formato non supportato. Usa JPG, PNG o WebP.');
  }

  // Validazione dimensione
  if (file.size > MAX_FILE_SIZE) {
    throw new Error('File troppo grande. Massimo 2MB.');
  }

  // Upload
  const storageRef = ref(storage, `users/${userId}/logo`);
  try {
    await uploadBytes(storageRef, file);
    // Ottieni URL pubblico
    return await getDownloadURL(storageRef);
  } catch (err) {
    throw mapStorageError(err);
  }
}

export async function deleteUserLogo(userId) {
  const storageRef = ref(storage, `users/${userId}/logo`);
  try {
    await deleteObject(storageRef);
  } catch (err) {
    // Ignora se non esiste
    if (err.code !== 'storage/object-not-found') throw err;
  }
}
